import { LoadPermitToWorkTable } from '../../permit-to-work-user/state/permit-to-work.actions';
import { getDepartmentId } from 'src/app/services/store-snapshot.service';
import { LoadQuantityTypes } from 'src/app/quantity-type/state/quantity-type.actions';
import { LoadDepartments } from 'src/app/department/state/department.actions';
import { LoadTenants } from 'src/app/tenant/state/tenant.action';
import { LoadDepartmentGroups } from 'src/app/department/state/department-group.actions';
import { LoadShifts } from 'src/app/crew-management/state/shifts/shift.actions';
import { LoadActivities } from 'src/app/crew-management/state/activities/activity.actions';
import { LoadJobPositions } from 'src/app/competence/state/job-position.actions';
import { LoadJobPositionGroups } from 'src/app/competence/state/job-position-group.actions';
import { LoadCompetenceGroups } from 'src/app/competence/state/competence-group.actions';
import { LoadCompetences } from 'src/app/competence/state/competence.actions';
import { Injectable } from '@angular/core';
import {
  StateToken,
  State,
  Action,
  StateContext,
  Selector,
  createSelector,
  ofActionSuccessful,
  NgxsOnInit,
  Actions,
} from '@ngxs/store';
import {
  TableFilterScope,
  TableFilterStorageService,
} from '../services/table-filter-storage.service';
import { append, patch, updateItem } from '@ngxs/store/operators';
import { LoadDocuments } from 'src/app/document-user/state/document.actions';
import {
  LoadAdminDocumentReadReceiptRequests,
  LoadUserDocumentReadReceipts,
} from 'src/app/document-user/state/document.actions';
import {
  MainTableFilterModel,
  MainTableFilterSearchByModel,
  MainTableSortingType,
} from 'src/app/shared/models/main-table-filter.model';
import { getUserActivitiesUserId } from 'src/app/shared/user-view/functions/get-user-activities-user-id';
import { LoadUserCompetences } from 'src/app/shared/user-view/state/competence-user.actions';
import {
  LoadMyUserActivities,
  LoadUserActivities,
} from 'src/app/shared/user-view/state/user-activities.actions';
import {
  LoadAllUsersAllTenants,
  LoadUserLog,
  LoadUsers,
} from 'src/app/shared/user-view/state/user.actions';
import {
  LoadPlannedActivities,
  LoadPlannedActivitiesForTenant,
  LoadPlannedActivitiesUsers,
} from 'src/app/crew-management-user/state/planned-activities/planned-activities.actions';
import { LoadRunTimesForDepartment } from 'src/app/run-time/state/run-time.actions';
import { LoadSeverities } from 'src/app/non-conformance-admin/state/severities/severity.actions';
import {
  LoadCurrentPersonnel,
  LoadMissingConfirmations,
} from 'src/app/crew-management-user/state/current-personnel/current-personnel.actions';
import {
  LoadCurrentAndPlannedPaxOverviews,
  LoadCurrentPaxOverviews,
  LoadPastPaxOverviews,
  LoadPlannedPaxOverviews,
} from 'src/app/crew-management-user/state/pax-overview/pax-overview.actions';
import { LoadAlerts } from 'src/app/alert/state/alert.actions';
import { LoadCompetenceRequirements } from 'src/app/competence/state/competence-requirement.actions';
import {
  LoadMedicineStock,
  LoadPagedMedicines,
} from 'src/app/medicine-user/state/medicine.actions';
import { LoadProductCategories } from 'src/app/storage-admin/state/product-category.actions';
import { LoadProducts } from 'src/app/storage-user/state/product.actions';
import { LoadTenantChemicalExposureLog } from 'src/app/storage-user/state/tenant-chemical-exposure-log.actions';
import {
  LoadMyUserChemicalExposureLog,
  LoadUserChemicalExposureLog,
} from 'src/app/storage-user/state/user-chemical-exposure-log.actions';
import { LoadPaxes } from 'src/app/user/state/pax.actions';
import { LoadNonConformanceTypes } from 'src/app/non-conformance-admin/state/types/non-conformance-type.actions';
import { LoadPermitToWorkTypes } from 'src/app/permit-to-work-admin/state/permit-to-work-type.actions';
import { LoadPermitToWorkLocationTypes } from 'src/app/permit-to-work-admin/state/permit-to-work-location-type.actions';
import { LoadSuppliers } from 'src/app/order-admin/state/supplier/supplier.actions';
import { LoadDrills } from 'src/app/drills-user/state/drills.actions';
import { LoadPurchasers } from 'src/app/order-admin/state/purchaser/purchaser.actions';
import { cloneDeep } from 'lodash-es';
import {
  LoadApprovedOrders,
  LoadOrdersSentToSuppliers,
  LoadPagedOrders,
} from 'src/app/order-user/state/order.actions';
import { LoadOrderTypes } from 'src/app/order-admin/state/order-types/order-type.actions';
import { LoadSeaStates } from 'src/app/non-conformance-admin/state/sea-state/non-conformance-sea-state.actions';
import { LoadLocationOnDepartments } from 'src/app/non-conformance-admin/state/location-on-department/non-conformance-location-on-department.actions';
import { LoadWeatherInformation } from 'src/app/non-conformance-admin/state/weather-information/non-conformance-weather-information.actions';
import { LoadRiskAssessments } from 'src/app/risk-assessment-user/state/risk-assessment.actions';
import { LoadRiskAssessmentValues } from 'src/app/risk-assessment-admin/state/risk-assessment-value.actions';
import { RiskAssessmentValueType } from 'src/app/risk-assessment-admin/enums/risk-assessment-value-type.enum';
import { LoadCauses } from 'src/app/non-conformance-admin/state/cause/non-conformance-cause.actions';
import { LoadCustomProperties } from 'src/app/non-conformance-admin/state/custom-property/custom-property.actions';
import { LoadCertificateTypes } from 'src/app/certificate-admin/state/certificate-types.action';
import { LoadPrivilegeTemplates } from 'src/app/competence/state/privilege-template.actions';
import {
  LoadTrips,
  LoadTripsChangeLog,
} from 'src/app/crew-management-user/state/trips/trip.actions';
import { LoadShiftManningAdminLog } from 'src/app/crew-management-user/state/shift-manning-admin-log/shift-manning-admin-log.actions';
import {
  LoadDueListDueCompetences,
  LoadDueListWarnings,
  LoadMyDueListWarnings,
} from 'src/app/due-list/state/due-list.actions';
import {
  LoadComponentSpareParts,
  LoadJobSpareParts,
} from 'src/app/maintenance-user/state/spare-part.actions';
import { LoadProductTypes } from 'src/app/storage-admin/state/product-type.actions';
import { LoadExposureDurations } from 'src/app/storage-admin/state/exposure-duration.actions';
import {
  LoadComponentProductTypes,
  LoadJobProductTypes,
} from 'src/app/maintenance-user/state/product-type-user.actions';
import { GetComponentHistoryById } from 'src/app/maintenance-user/state/component-history.actions';
import { LoadStandardJobTemplates } from 'src/app/maintenance-admin/state/standard-job-template.actions';
import {
  LoadEntraIdDepartmentMappings,
  LoadEntraIdJobPositionMappings,
  LoadEntraIdShiftMappings,
} from 'src/app/tenant/state/entra-id-mapping.actions';
import { LoadCompetenceRoles } from 'src/app/competence/state/competence-roles.actions';
import {
  LoadAllWorkScheduleTemplates,
  LoadWorkScheduleTemplates,
} from 'src/app/work-and-rest-admin/state/work-schedule-template/work-schedule-template.actions';
import { LoadOvertimeTypes } from 'src/app/work-and-rest-admin/state/overtime-type/overtime-type.actions';
import { LoadWorkPlanTemplates } from 'src/app/work-and-rest-admin/state/work-plan-template/work-plan-template.actions';
import { LoadWorkOverviewList } from 'src/app/work-and-rest-user/state/work-overview.actions';
import {
  LoadAdditionalTimeHistory,
  LoadAdditionalTimeRequests,
} from 'src/app/work-and-rest-user/state/additional-time.actions';
import { LoadSignedOffDocumentsList } from 'src/app/work-and-rest-user/state/sign-off.actions';
import {
  ChangeCurrentSelectedTenant,
  LoadTenantUserAccess,
} from 'src/app/tenant-selector/state/tenant-user-access.actions';
import { LoadMyUserCompetences } from '../../shared/user-view/state/competence-user.actions';
import { LoadTasks } from '../../task-user/state/task.actions';
import { LoadDeliveryConditions } from '../../order-admin/state/delivery-condition.actions';
import { LoadAccountGroups } from '../../order-admin/state/account-group.actions';
import { LoadAccounts } from '../../order-admin/state/account.actions';
import { LoadDocumentsByMenu } from '../../document-user/state/document.actions';
import { LoadMedicineCategories } from '../../medicine-admin/state/medicine-category.actions';
import { LoadMessages } from '../../message/state/send-message-log.actions';
import { LoadProductOwners } from '../../product-owner/state/product-owner.actions';
import { LoadJobTypes } from '../../maintenance-admin/state/job-type.actions';
import { LoadJobAreas } from '../../maintenance-admin/state/job-area.actions';
import { LoadMaintenanceJobs } from '../../maintenance-user/state/maintenance-job.actions';
import { LoadNonConformances } from '../../non-conformance-user/state/non-conformance.actions';
import {
  LoadCertificateGroups,
  LoadCertificateLog,
  LoadCertificatesByMenu,
} from '../../certificate-user/state/certificate.actions';
import { LoadDepartmentPauseLog } from '../../department/state/department-pause.actions';
import { MainTableFilterModulesEnum } from '../enums/main-table-filter-modules.enum';

import {
  ApplySearch,
  ApplyPaging,
  ApplyAdditional,
  ApplySorting,
  ClearFilterDetails,
  ReFetchWithLastFilters,
  ApplyColumnFilters,
  ReFetchAndClearSorting,
  ResetFilterPageIndex,
  ResetCurrentFilter,
  ResetFilterSearch,
  ResetFilterSearchTerm,
  ClearModuleFilters,
  ClearModuleColumnFilters,
  ResetFilterPageSize,
  LoadSavedFilterSettings,
  ActivateTableFilterScope,
  ClearAllSavedFilters,
  RestoreCurrentFilter,
} from './main-table-filter.actions';
import { MainTableFilterIdentification } from '../models/main-table-filter-identification.model';
import { defaultInitialPageSize, defaultPageIndex } from '../table-config/table-paging-defaults';
import { LoadDeliveryAddresses } from 'src/app/order-admin/state/delivery-address/delivery-address.actions';
import { LoadProjects } from '../../maintenance-user/state/project.actions';
import { LoadSfiCodes } from 'src/app/order-admin/state/sfi-code.actions';

export interface MainTableFilterStateModel {
  filtersByModule: MainTableFilterModel[];
  currentFilter: MainTableFilterModel | undefined;
  previousModule: MainTableFilterModulesEnum | undefined;
  previousDepartment: string | undefined;
  modulePageSizes: { [key: string]: number };
  moduleSearchBy: { [key: string]: MainTableFilterSearchByModel[] };
  moduleSorting: { [key: string]: { orderBy: string; ascDesc: MainTableSortingType } };
  moduleSearchTerm: { [key: string]: string };
  searchTermByScope: Partial<Record<TableFilterScope, { [key: string]: string }>>;
}

const MAIN_TABLE_FILTER_STATE_TOKEN = new StateToken<MainTableFilterStateModel>('mainTableFilter');

@State<MainTableFilterStateModel>({
  name: MAIN_TABLE_FILTER_STATE_TOKEN,
  defaults: {
    filtersByModule: [],
    currentFilter: undefined,
    previousModule: undefined,
    previousDepartment: undefined,
    modulePageSizes: {},
    moduleSearchBy: {},
    moduleSorting: {},
    moduleSearchTerm: {},
    searchTermByScope: {},
  },
})
@Injectable()
export class MainTableFilterState implements NgxsOnInit {
  constructor(
    private actions$: Actions,
    private tableFilterStorageService: TableFilterStorageService
  ) {}
  private readonly actionMap: { [key: string]: (f: MainTableFilterModel) => any } = {
    [MainTableFilterModulesEnum.PermitToWork]: (f) => new LoadPermitToWorkTable(f),
    [MainTableFilterModulesEnum.PermitToWorkTypes]: (f) => new LoadPermitToWorkTable(f),
    [MainTableFilterModulesEnum.PermitToWorkLocations]: (f) => new LoadPermitToWorkTable(f),
    [MainTableFilterModulesEnum.PermitToWorkLogs]: (f) => new LoadPermitToWorkTable(f),
    [MainTableFilterModulesEnum.Certificates]: (f) => new LoadCertificatesByMenu(f),
    [MainTableFilterModulesEnum.CertificateStructures]: (f) => new LoadCertificateGroups(f),
    [MainTableFilterModulesEnum.Competences]: (f) => new LoadCompetences(f.additional, f),
    [MainTableFilterModulesEnum.CompetenceGroups]: (f) => new LoadCompetenceGroups(f.additional, f),
    [MainTableFilterModulesEnum.CompetenceUsers]: (f) => new LoadUserCompetences(f.additional, f),
    [MainTableFilterModulesEnum.MyCompetenceUsers]: (f) =>
      new LoadMyUserCompetences(f.additional, f),
    [MainTableFilterModulesEnum.CompetenceRequirement]: (f) => new LoadCompetenceRequirements(f),
    [MainTableFilterModulesEnum.PositionGroups]: (f) => new LoadJobPositionGroups(f),
    [MainTableFilterModulesEnum.CompetenceRoles]: (f) => new LoadCompetenceRoles(f),
    [MainTableFilterModulesEnum.JobPositions]: (f) => new LoadJobPositions(f),
    [MainTableFilterModulesEnum.Activities]: (f) => new LoadActivities(f),
    [MainTableFilterModulesEnum.Shifts]: (f) => new LoadShifts(f),
    [MainTableFilterModulesEnum.Trips]: (f) => new LoadTrips(f),
    [MainTableFilterModulesEnum.Documents]: (f) => new LoadDocuments(f, f.additional),
    [MainTableFilterModulesEnum.DocumentsByMenu]: (f) => new LoadDocumentsByMenu(f),
    [MainTableFilterModulesEnum.AdminDocumentReadReceipts]: (f) =>
      new LoadAdminDocumentReadReceiptRequests(f),
    [MainTableFilterModulesEnum.UserDocumentReadReceipts]: (f) =>
      new LoadUserDocumentReadReceipts(f.additional, f),
    [MainTableFilterModulesEnum.DepartmentGroups]: (f) => new LoadDepartmentGroups(f),
    [MainTableFilterModulesEnum.JobTypes]: (f) => new LoadJobTypes(f),
    [MainTableFilterModulesEnum.JobAreas]: (f) => new LoadJobAreas(f),
    [MainTableFilterModulesEnum.StandardJobTemplates]: (f) => new LoadStandardJobTemplates(f),
    [MainTableFilterModulesEnum.MaintenanceJobs]: (f) => new LoadMaintenanceJobs(f),
    [MainTableFilterModulesEnum.Drills]: (f) => new LoadDrills(f),
    [MainTableFilterModulesEnum.Tasks]: (f) => new LoadTasks(f),
    [MainTableFilterModulesEnum.NonConformances]: (f) => new LoadNonConformances(f.additional, f),
    [MainTableFilterModulesEnum.NonConformanceTypes]: (f) => new LoadNonConformanceTypes(f),
    [MainTableFilterModulesEnum.PermitToWorkAdminTypes]: (f) => new LoadPermitToWorkTypes(f),
    [MainTableFilterModulesEnum.PermitToWorkLocationTypes]: (f) =>
      new LoadPermitToWorkLocationTypes(f),
    [MainTableFilterModulesEnum.NonConformanceCauses]: (f) => new LoadCauses(f),
    [MainTableFilterModulesEnum.NonConformanceSeaStates]: (f) => new LoadSeaStates(f),
    [MainTableFilterModulesEnum.NonConformanceWeatherInformation]: (f) =>
      new LoadWeatherInformation(f),
    [MainTableFilterModulesEnum.NonConformanceLocationOnDepartment]: (f) =>
      new LoadLocationOnDepartments(f),
    [MainTableFilterModulesEnum.NonConformanceCustomProperties]: (f) => new LoadCustomProperties(f),
    [MainTableFilterModulesEnum.Users]: (f) => new LoadUsers(f),
    [MainTableFilterModulesEnum.UserLog]: (f) => new LoadUserLog(f.additional, f),
    [MainTableFilterModulesEnum.UserActivities]: (f) =>
      new LoadUserActivities(getUserActivitiesUserId(f.additional), f),
    [MainTableFilterModulesEnum.MyUserActivities]: (f) =>
      new LoadMyUserActivities(getUserActivitiesUserId(f.additional), f),
    [MainTableFilterModulesEnum.UserChemicalExposureLog]: (f) =>
      new LoadUserChemicalExposureLog(f.additional, f),
    [MainTableFilterModulesEnum.MyUserChemicalExposureLog]: (f) =>
      new LoadMyUserChemicalExposureLog(f.additional, f),
    [MainTableFilterModulesEnum.TenantChemicalExposureLog]: (f) =>
      new LoadTenantChemicalExposureLog(f),
    [MainTableFilterModulesEnum.Messages]: (f) => new LoadMessages(f),
    [MainTableFilterModulesEnum.ProductOwnerUsers]: (f) => new LoadAllUsersAllTenants(f),
    [MainTableFilterModulesEnum.PlannedActivities]: (f) => new LoadPlannedActivities(f),
    [MainTableFilterModulesEnum.PlannedActivitiesForTenant]: (f) =>
      new LoadPlannedActivitiesForTenant(f),
    [MainTableFilterModulesEnum.ProductOwner]: (f) => new LoadProductOwners(f),
    [MainTableFilterModulesEnum.Tenant]: (f) => new LoadTenants(f),
    [MainTableFilterModulesEnum.Departments]: (f) => new LoadDepartments(f),
    [MainTableFilterModulesEnum.RunTime]: (f) => new LoadRunTimesForDepartment(f),
    [MainTableFilterModulesEnum.MedicineCategories]: (f) => new LoadMedicineCategories(f),
    [MainTableFilterModulesEnum.Medicines]: (f) => new LoadPagedMedicines(f, f.additional),
    [MainTableFilterModulesEnum.MedicineStock]: (f) => new LoadMedicineStock(f.additional, f),
    [MainTableFilterModulesEnum.ProductCategories]: (f) => new LoadProductCategories(f),
    [MainTableFilterModulesEnum.Products]: (f) => new LoadProducts(f, f.additional),
    [MainTableFilterModulesEnum.Severities]: (f) => new LoadSeverities(f),
    [MainTableFilterModulesEnum.CurrentPersonnel]: (f) => new LoadCurrentPersonnel(f),
    [MainTableFilterModulesEnum.MissingConfirmation]: (f) => new LoadMissingConfirmations(f),
    [MainTableFilterModulesEnum.CurrentPaxOverview]: (f) => new LoadCurrentPaxOverviews(f),
    [MainTableFilterModulesEnum.PlannedPaxOverview]: (f) => new LoadPlannedPaxOverviews(f),
    [MainTableFilterModulesEnum.PastPaxOverview]: (f) => new LoadPastPaxOverviews(f),
    [MainTableFilterModulesEnum.CurrentAndPlannedPaxOverview]: (f) =>
      new LoadCurrentAndPlannedPaxOverviews(f),
    [MainTableFilterModulesEnum.AdminPaxes]: (f) => new LoadPaxes(f),
    [MainTableFilterModulesEnum.Alerts]: (f) => new LoadAlerts(f),
    [MainTableFilterModulesEnum.Accounts]: (f) => new LoadAccounts(f),
    [MainTableFilterModulesEnum.SfiCodes]: (f) => new LoadSfiCodes(f),
    [MainTableFilterModulesEnum.AccountGroups]: (f) => new LoadAccountGroups(f),
    [MainTableFilterModulesEnum.DeliveryConditions]: (f) => new LoadDeliveryConditions(f),
    [MainTableFilterModulesEnum.QuantityTypes]: (f) => new LoadQuantityTypes(f),
    [MainTableFilterModulesEnum.Suppliers]: (f) => new LoadSuppliers(f),
    [MainTableFilterModulesEnum.Purchasers]: (f) => new LoadPurchasers(f),
    [MainTableFilterModulesEnum.PlannedActivityUsers]: (f) => new LoadPlannedActivitiesUsers(f),
    [MainTableFilterModulesEnum.Orders]: (f) => new LoadPagedOrders(f.additional, f),
    [MainTableFilterModulesEnum.OrderTypes]: (f) => new LoadOrderTypes(f),
    [MainTableFilterModulesEnum.ApprovedOrders]: (f) => new LoadApprovedOrders(f),
    [MainTableFilterModulesEnum.OrdersSentToSupplier]: (f) => new LoadOrdersSentToSuppliers(f),
    [MainTableFilterModulesEnum.RiskAssessments]: (f) => new LoadRiskAssessments(f, f.additional),
    [MainTableFilterModulesEnum.Hazards]: (f) =>
      new LoadRiskAssessmentValues(RiskAssessmentValueType.Hazard, f),
    [MainTableFilterModulesEnum.Consequences]: (f) =>
      new LoadRiskAssessmentValues(RiskAssessmentValueType.Consequence, f),
    [MainTableFilterModulesEnum.Locations]: (f) =>
      new LoadRiskAssessmentValues(RiskAssessmentValueType.Location, f),
    [MainTableFilterModulesEnum.OperationTypes]: (f) =>
      new LoadRiskAssessmentValues(RiskAssessmentValueType.OperationType, f),
    [MainTableFilterModulesEnum.MitigatingMeasures]: (f) =>
      new LoadRiskAssessmentValues(RiskAssessmentValueType.MitigatingMeasure, f),
    [MainTableFilterModulesEnum.CertificateTypes]: (f) => new LoadCertificateTypes(f),
    [MainTableFilterModulesEnum.CertificateLog]: (f) => new LoadCertificateLog(f.additional, f),
    [MainTableFilterModulesEnum.DepartmentPauseLog]: (f) =>
      new LoadDepartmentPauseLog(f.additional, f),
    [MainTableFilterModulesEnum.PrivilegeTemplates]: (f) => new LoadPrivilegeTemplates(f),
    [MainTableFilterModulesEnum.DueListWarnings]: (f) =>
      new LoadDueListWarnings(f, f.additional?.displayRuntimeChildren),
    [MainTableFilterModulesEnum.DueListCompetences]: (f) =>
      new LoadDueListDueCompetences(f, f.additional?.displayRuntimeChildren),
    [MainTableFilterModulesEnum.DueListMyWarnings]: (f) =>
      new LoadMyDueListWarnings(f, f.additional?.displayRuntimeChildren),
    [MainTableFilterModulesEnum.ComponentSpareParts]: (f) =>
      new LoadComponentSpareParts(f.additional, f),
    [MainTableFilterModulesEnum.ComponentHistory]: (f) =>
      new GetComponentHistoryById(f.additional, f),
    [MainTableFilterModulesEnum.JobSpareParts]: (f) => new LoadJobSpareParts(f.additional, f),
    [MainTableFilterModulesEnum.ComponentProductTypes]: (f) =>
      new LoadComponentProductTypes(f.additional, f),
    [MainTableFilterModulesEnum.JobProductTypes]: (f) => new LoadJobProductTypes(f.additional, f),
    [MainTableFilterModulesEnum.ProductTypes]: (f) => new LoadProductTypes(f),
    [MainTableFilterModulesEnum.ExposureDurations]: (f) => new LoadExposureDurations(f),
    [MainTableFilterModulesEnum.TripsChangeLog]: (f) => new LoadTripsChangeLog(f),
    [MainTableFilterModulesEnum.ShiftManningAdminLog]: (f) => new LoadShiftManningAdminLog(f),
    [MainTableFilterModulesEnum.EntraIdDepartmentMappings]: (f) =>
      new LoadEntraIdDepartmentMappings(f),
    [MainTableFilterModulesEnum.EntraIdJobPositionMappings]: (f) =>
      new LoadEntraIdJobPositionMappings(f),
    [MainTableFilterModulesEnum.EntraIdShiftMappings]: (f) => new LoadEntraIdShiftMappings(f),
    [MainTableFilterModulesEnum.WorkScheduleTemplates]: (f) => new LoadWorkScheduleTemplates(f),
    [MainTableFilterModulesEnum.WorkScheduleTemplatesAll]: (f) =>
      new LoadAllWorkScheduleTemplates(f),
    [MainTableFilterModulesEnum.OvertimeTypes]: (f) => new LoadOvertimeTypes(f),
    [MainTableFilterModulesEnum.WorkRest]: (f) => new LoadWorkOverviewList(f.additional, f),
    [MainTableFilterModulesEnum.TimeApprovals]: (f) => new LoadAdditionalTimeRequests(f),
    [MainTableFilterModulesEnum.WorkPlanTemplates]: (f) => new LoadWorkPlanTemplates(f),
    [MainTableFilterModulesEnum.SignOffHistory]: (f) => new LoadSignedOffDocumentsList(f),
    [MainTableFilterModulesEnum.WorkApprovalHistory]: (f) => new LoadAdditionalTimeHistory(f),
    [MainTableFilterModulesEnum.DeliveryAddresses]: (f) => new LoadDeliveryAddresses(f),
    [MainTableFilterModulesEnum.Projects]: (f) => new LoadProjects(f),
  };

  ngxsOnInit(ctx: StateContext<MainTableFilterStateModel>): void {
    // Clear all filters from localStorage on tenant change
    this.actions$.pipe(ofActionSuccessful(ChangeCurrentSelectedTenant)).subscribe(() => {
      this.tableFilterStorageService.clearAllFiltersOnTenantChange();
      ctx.setState(
        patch({
          moduleSearchBy: {},
          moduleSorting: {},
          moduleSearchTerm: {},
          searchTermByScope: {},
        })
      );
    });

    // Load saved filter settings when user access is loaded
    this.actions$.pipe(ofActionSuccessful(LoadTenantUserAccess)).subscribe(() => {
      ctx.dispatch(new LoadSavedFilterSettings());
    });
  }

  @Action(ApplySearch, { cancelUncompleted: true })
  applySearch(
    ctx: StateContext<MainTableFilterStateModel>,
    { module, searchTerm, additional }: ApplySearch
  ) {
    const existingFilter = this.findFilter(ctx.getState().filtersByModule, module, additional);
    const newFilter = existingFilter || new MainTableFilterModel(module);
    newFilter.departmentId = existingFilter?.departmentId || getDepartmentId();
    newFilter.searchTerm = searchTerm;
    newFilter.pageIndex = 0;
    if (additional !== undefined) newFilter.additional = additional;
    if (existingFilter) {
      this.updateExistingFilter(ctx, newFilter, module, additional);
    } else {
      this.addNewFilter(ctx, newFilter);
    }
    this.setModuleSearchTerm(ctx, module, searchTerm);
    this.dispatchFilterToProperModule(newFilter, module, ctx);
  }

  @Action(ApplyAdditional, { cancelUncompleted: true })
  applyAdditional(
    ctx: StateContext<MainTableFilterStateModel>,
    { module, additional, method }: ApplyAdditional
  ) {
    const { filtersByModule } = ctx.getState();
    const existingFilter = this.findFilter(filtersByModule, module, additional);
    const newFilter = existingFilter || new MainTableFilterModel(module);
    newFilter.departmentId = existingFilter?.departmentId || getDepartmentId();
    newFilter.additional =
      method === 'merge' ? { ...(existingFilter?.additional ?? {}), ...additional } : additional;
    if (existingFilter) {
      newFilter.pageIndex = 0;
      this.updateExistingFilter(ctx, newFilter, module, additional);
    } else {
      this.addNewFilter(ctx, newFilter);
    }
    this.dispatchFilterToProperModule(newFilter, module, ctx);
  }

  @Action(RestoreCurrentFilter)
  restoreCurrentFilter(
    ctx: StateContext<MainTableFilterStateModel>,
    { previousCurrentFilter }: RestoreCurrentFilter
  ) {
    const state = ctx.getState();
    if (state.currentFilter !== undefined) {
      return;
    }
    ctx.setState(patch({ currentFilter: previousCurrentFilter }));
  }

  @Action(ApplyPaging, { cancelUncompleted: true })
  applyPaging(
    ctx: StateContext<MainTableFilterStateModel>,
    { module, pageIndex, pageSize, additional, initialFilters }: ApplyPaging
  ) {
    const existingFilter = this.findFilter(ctx.getState().filtersByModule, module, additional);

    // Get values from state, falling back to localStorage if state is empty
    const savedSettings = this.tableFilterStorageService.loadSettings();
    const existingModuleSearchBy =
      ctx.getState().moduleSearchBy[module] ?? savedSettings?.moduleSearchBy[module];
    const existingModuleSearchTerm = ctx.getState().moduleSearchTerm[module];
    const existingModuleSorting =
      ctx.getState().moduleSorting[module] ?? savedSettings?.moduleSorting[module];

    const newFilter = cloneDeep(existingFilter) || new MainTableFilterModel(module);
    newFilter.departmentId = existingFilter?.departmentId || getDepartmentId();
    newFilter.pageSize = pageSize;
    newFilter.searchBy = initialFilters || existingModuleSearchBy;
    newFilter.searchTerm = existingModuleSearchTerm;
    newFilter.orderBy = existingModuleSorting?.orderBy;
    newFilter.ascDesc = existingModuleSorting?.ascDesc;
    if (additional !== undefined) newFilter.additional = additional;
    if (existingFilter) {
      // if pageSize changes, then always go to pageIndex 0
      newFilter.pageIndex = pageSize !== existingFilter.pageSize ? 0 : pageIndex;
      this.updateExistingFilter(ctx, newFilter, module, additional);
    } else {
      this.addNewFilter(ctx, newFilter);
    }
    this.setModulePageSize(ctx, module, newFilter.pageSize);

    // Note: When initialFilters are provided (e.g., from route params), we intentionally
    // do NOT update the in-memory state or localStorage. They are applied to the current
    // request only (via newFilter.searchBy above).
    if (!initialFilters && existingModuleSearchBy && !ctx.getState().moduleSearchBy[module]) {
      ctx.setState(
        patch({
          moduleSearchBy: {
            ...ctx.getState().moduleSearchBy,
            [module]: existingModuleSearchBy,
          },
        })
      );
    }
    if (existingModuleSorting && !ctx.getState().moduleSorting[module]) {
      ctx.setState(
        patch({
          moduleSorting: {
            ...ctx.getState().moduleSorting,
            [module]: existingModuleSorting,
          },
        })
      );
    }
    if (existingModuleSearchTerm && !ctx.getState().moduleSearchTerm[module]) {
      ctx.setState(
        patch({
          moduleSearchTerm: {
            ...ctx.getState().moduleSearchTerm,
            [module]: existingModuleSearchTerm,
          },
        })
      );
    }

    this.dispatchFilterToProperModule(newFilter, module, ctx);
  }

  @Action(ApplySorting, { cancelUncompleted: true })
  applySorting(
    ctx: StateContext<MainTableFilterStateModel>,
    { module, orderBy, ascDesc, additional }: ApplySorting
  ) {
    const existingFilter = this.findFilter(ctx.getState().filtersByModule, module, additional);
    const newFilter = existingFilter || new MainTableFilterModel(module);
    newFilter.departmentId = existingFilter?.departmentId || getDepartmentId();
    newFilter.orderBy = orderBy;
    newFilter.ascDesc = ascDesc;
    if (existingFilter) {
      this.updateExistingFilter(ctx, existingFilter, module, additional);
    } else {
      newFilter.additional = additional;
      this.addNewFilter(ctx, newFilter);
    }
    this.setModuleSorting(ctx, module, orderBy, ascDesc);
    this.dispatchFilterToProperModule(newFilter, module, ctx);
  }

  @Action(ApplyColumnFilters, { cancelUncompleted: true })
  applyColumnFilters(
    ctx: StateContext<MainTableFilterStateModel>,
    { module, filters, additional }: ApplyColumnFilters
  ) {
    const existingFilter = this.findFilter(ctx.getState().filtersByModule, module, additional);
    const newFilter = existingFilter || new MainTableFilterModel(module);
    newFilter.searchBy = filters;
    newFilter.pageIndex = 0;
    if (existingFilter) {
      this.updateExistingFilter(ctx, existingFilter, module, additional);
    } else {
      newFilter.additional = additional;
      this.addNewFilter(ctx, newFilter);
    }
    this.setModuleSearchBy(ctx, module, filters);
    this.dispatchFilterToProperModule(newFilter, module, ctx);
  }

  @Action(ReFetchWithLastFilters, { cancelUncompleted: true })
  reFetch(
    ctx: StateContext<MainTableFilterStateModel>,
    { module, additional }: ReFetchWithLastFilters
  ) {
    const existingFilter = this.findFilter(ctx.getState().filtersByModule, module, additional);
    if (existingFilter) {
      this.dispatchFilterToProperModule(existingFilter, module, ctx);
    } else {
      console.warn('ReFetch: No filter found for module: ', module);
    }
  }

  @Action(ReFetchAndClearSorting, { cancelUncompleted: true })
  reFetchAndClearSorting(
    ctx: StateContext<MainTableFilterStateModel>,
    { module, additional }: ReFetchAndClearSorting
  ) {
    const existingFilter = this.findFilter(ctx.getState().filtersByModule, module, additional);

    if (existingFilter) {
      existingFilter.orderBy = '';
      existingFilter.ascDesc = '';
      this.setModuleSorting(ctx, module, '', '');
      this.dispatchFilterToProperModule(existingFilter, module, ctx);
    } else {
      console.warn('ReFetch: No filter found for module: ', module);
    }
  }

  @Action(ClearFilterDetails, { cancelUncompleted: true })
  clearFilterDetails(ctx: StateContext<MainTableFilterStateModel>) {
    const allFilters = ctx.getState().filtersByModule;
    const clearedFilters = allFilters.map((filter: MainTableFilterModel) => {
      const clearedFilter = new MainTableFilterModel(filter.module);
      clearedFilter.pageSize = filter.pageSize;
      clearedFilter.additional = filter.additional;
      return clearedFilter;
    });
    ctx.setState(
      patch({
        filtersByModule: clearedFilters,
        moduleSearchBy: {},
        moduleSorting: {},
      })
    );
  }

  @Action(ClearModuleFilters, { cancelUncompleted: true })
  clearModuleFilters(ctx: StateContext<MainTableFilterStateModel>, { module }: ClearModuleFilters) {
    const clearedFilters = ctx.getState().filtersByModule.map((filter: MainTableFilterModel) => {
      if (filter.module === module) {
        return new MainTableFilterModel(filter.module);
      }
      return filter;
    });
    ctx.setState(
      patch({
        filtersByModule: clearedFilters,
        moduleSearchBy: patch({
          [module]: [],
        }),
        moduleSorting: patch({
          [module]: { orderBy: '', ascDesc: '' },
        }),
        moduleSearchTerm: patch({
          [module]: '',
        }),
      })
    );
    this.rememberSearchTermForCurrentScope(ctx, module, '');
    this.tableFilterStorageService.saveModuleSearchTerm(module, '');
  }

  @Action(ClearModuleColumnFilters, { cancelUncompleted: true })
  clearModuleColumnFilters(
    ctx: StateContext<MainTableFilterStateModel>,
    { module, column }: ClearModuleColumnFilters
  ) {
    const state = ctx.getState();
    const hasColumnToClear =
      (state.currentFilter?.module === module &&
        this.filterHasColumn(state.currentFilter, column)) ||
      state.filtersByModule.some(
        (filter) => filter.module === module && this.filterHasColumn(filter, column)
      ) ||
      (state.moduleSearchBy[module] ?? []).some((item) => item.property === column) ||
      state.moduleSorting[module]?.orderBy === column;

    if (!hasColumnToClear) {
      return;
    }

    const shouldRefetch =
      !!state.currentFilter &&
      state.currentFilter.module === module &&
      this.filterHasColumn(state.currentFilter, column);
    const filtersByModule = state.filtersByModule.map((filter) =>
      filter.module === module ? this.clearColumnFromFilter(filter, column) : filter
    );
    const currentFilter =
      state.currentFilter?.module === module
        ? this.clearColumnFromFilter(state.currentFilter, column)
        : state.currentFilter;
    const moduleSearchBy = this.clearColumnFromModuleSearchBy(state.moduleSearchBy, module, column);
    const moduleSorting = this.clearColumnFromModuleSorting(state.moduleSorting, module, column);

    ctx.setState(
      patch({
        filtersByModule,
        currentFilter,
        moduleSearchBy,
        moduleSorting,
      })
    );
    this.tableFilterStorageService.clearModuleColumnFilters(module, column);

    if (shouldRefetch && currentFilter?.module === module) {
      this.dispatchFilterToProperModule(currentFilter, module, ctx);
    }
  }

  @Action(ClearAllSavedFilters)
  clearAllSavedFilters(ctx: StateContext<MainTableFilterStateModel>) {
    this.tableFilterStorageService.clearSettings();
    const allFilters = ctx.getState().filtersByModule;
    const clearedFilters = allFilters.map((filter: MainTableFilterModel) => {
      const clearedFilter = new MainTableFilterModel(filter.module);
      clearedFilter.pageSize = filter.pageSize;
      clearedFilter.additional = filter.additional;
      return clearedFilter;
    });
    ctx.setState(
      patch({
        filtersByModule: clearedFilters,
        moduleSearchBy: {},
        moduleSorting: {},
        moduleSearchTerm: {},
        searchTermByScope: {},
      })
    );
  }

  @Action(ResetFilterPageIndex, { cancelUncompleted: true })
  resetCurrentFilterPage(
    ctx: StateContext<MainTableFilterStateModel>,
    { filterIdentification }: ResetFilterPageIndex
  ) {
    const { moduleName, additional } = filterIdentification;
    const filter = this.findFilter(
      ctx.getState().filtersByModule,
      moduleName as MainTableFilterModulesEnum,
      additional
    );
    if (filter) {
      filter.pageIndex = 0;
      this.updateExistingFilter(ctx, filter, moduleName as MainTableFilterModulesEnum, additional);
    }
  }

  @Action(ResetFilterPageSize, { cancelUncompleted: true })
  resetCurrentFilterPageSize(
    ctx: StateContext<MainTableFilterStateModel>,
    { filterIdentification }: ResetFilterPageSize
  ) {
    const { moduleName, additional } = filterIdentification;
    const filter = this.findFilter(
      ctx.getState().filtersByModule,
      moduleName as MainTableFilterModulesEnum,
      additional
    );
    if (filter) {
      filter.pageSize = defaultInitialPageSize;
      this.updateExistingFilter(ctx, filter, moduleName as MainTableFilterModulesEnum, additional);
    }
  }

  @Action(ResetFilterSearch, { cancelUncompleted: true })
  resetCurrentFilterSearch(
    ctx: StateContext<MainTableFilterStateModel>,
    { module, additional }: ResetFilterSearch
  ) {
    const filter = this.findFilter(
      ctx.getState().filtersByModule,
      module as MainTableFilterModulesEnum,
      additional
    );
    if (filter) {
      filter.searchBy = undefined;
      this.updateExistingFilter(ctx, filter, module as MainTableFilterModulesEnum, additional);
    }
  }

  @Action(ResetFilterSearchTerm, { cancelUncompleted: true })
  resetCurrentFilterSearchTerm(
    ctx: StateContext<MainTableFilterStateModel>,
    { module, additional }: ResetFilterSearchTerm
  ) {
    const filter = this.findFilter(
      ctx.getState().filtersByModule,
      module as MainTableFilterModulesEnum,
      additional
    );
    if (filter) {
      filter.searchTerm = undefined;
      this.updateExistingFilter(ctx, filter, module as MainTableFilterModulesEnum, additional);
    }
    this.setModuleSearchTerm(ctx, module, '');
  }

  @Action(ResetCurrentFilter, { cancelUncompleted: true })
  resetCurrentFilter(ctx: StateContext<MainTableFilterStateModel>) {
    ctx.setState(patch({ currentFilter: undefined }));
  }

  @Action(ActivateTableFilterScope)
  activateTableFilterScope(ctx: StateContext<MainTableFilterStateModel>) {
    const scope = this.tableFilterStorageService.currentTableScope();
    if (!scope) {
      return;
    }
    if (scope === 'department') {
      this.tableFilterStorageService.clearDepartmentScopedFiltersOnDepartmentChange();
      this.tableFilterStorageService.clearModuleFilters(MainTableFilterModulesEnum.WorkRest);
    }
    const savedSettings = this.tableFilterStorageService.loadSettings();
    const state = ctx.getState();
    const hasSessionSearch = Object.prototype.hasOwnProperty.call(state.searchTermByScope, scope);
    const moduleSearchTerm = hasSessionSearch
      ? state.searchTermByScope[scope] || {}
      : savedSettings?.moduleSearchTerm || {};
    const moduleSearchBy = savedSettings?.moduleSearchBy || {};
    const moduleSorting = savedSettings?.moduleSorting || {};
    ctx.setState(
      patch({
        moduleSearchBy,
        moduleSorting,
        moduleSearchTerm,
        searchTermByScope: {
          ...state.searchTermByScope,
          [scope]: moduleSearchTerm,
        },
        filtersByModule: state.filtersByModule.map((filter) =>
          this.applyScopeToFilter(filter, moduleSearchBy, moduleSorting, moduleSearchTerm)
        ),
        currentFilter: state.currentFilter
          ? this.applyScopeToFilter(
              state.currentFilter,
              moduleSearchBy,
              moduleSorting,
              moduleSearchTerm
            )
          : state.currentFilter,
      })
    );
  }

  @Action(LoadSavedFilterSettings)
  loadSavedFilterSettings(ctx: StateContext<MainTableFilterStateModel>) {
    const savedSettings = this.tableFilterStorageService.loadSettings();
    const scope = this.tableFilterStorageService.currentTableScope();
    if (savedSettings) {
      const moduleSearchTerm = savedSettings.moduleSearchTerm || {};
      ctx.setState(
        patch({
          modulePageSizes: savedSettings.modulePageSizes || {},
          moduleSearchBy: savedSettings.moduleSearchBy || {},
          moduleSorting: savedSettings.moduleSorting || {},
          moduleSearchTerm,
          ...(scope ? { searchTermByScope: { [scope]: moduleSearchTerm } } : {}),
        })
      );
    }
  }

  @Selector()
  static getCurrentPageIndex(state: MainTableFilterStateModel) {
    return state.currentFilter?.pageIndex || defaultPageIndex;
  }

  @Selector()
  static getAllPagingDetails(state: MainTableFilterStateModel) {
    return state.filtersByModule;
  }

  @Selector()
  static getCurrentFilterDetails(
    state: MainTableFilterStateModel
  ): MainTableFilterModel | undefined {
    return state.currentFilter;
  }

  static getModulePageSize(module: any): (state: MainTableFilterStateModel) => number | undefined {
    return createSelector([MainTableFilterState], (state: MainTableFilterStateModel) => {
      return state.modulePageSizes[module];
    });
  }

  static getModuleSearchBy(
    module: any
  ): (state: MainTableFilterStateModel) => MainTableFilterSearchByModel[] | undefined {
    return createSelector([MainTableFilterState], (state: MainTableFilterStateModel) => {
      return state.moduleSearchBy[module];
    });
  }

  static getModuleSorting(
    module: any
  ): (
    state: MainTableFilterStateModel
  ) => { orderBy: string; ascDesc: MainTableSortingType } | undefined {
    return createSelector([MainTableFilterState], (state: MainTableFilterStateModel) => {
      return state.moduleSorting[module];
    });
  }

  static getModuleSearchTerm(
    module: any
  ): (state: MainTableFilterStateModel) => string | undefined {
    return createSelector([MainTableFilterState], (state: MainTableFilterStateModel) => {
      return state.moduleSearchTerm[module];
    });
  }

  static getPagingDetails(
    filterIdentification: MainTableFilterIdentification
  ): (state: MainTableFilterStateModel) => MainTableFilterModel | undefined {
    return createSelector([MainTableFilterState], (state: MainTableFilterStateModel) => {
      return state.filtersByModule.find(
        MainTableFilterState.findFilterFn(
          filterIdentification.moduleName as MainTableFilterModulesEnum,
          filterIdentification.additional
        )
      );
    });
  }

  private findFilter(
    filters: MainTableFilterModel[],
    module: MainTableFilterModulesEnum,
    additional: any
  ) {
    return cloneDeep(
      filters.find(MainTableFilterState.findFilterFn(module, additional)) as MainTableFilterModel
    );
  }

  private static findFilterFn(module: MainTableFilterModulesEnum, additional: any) {
    const filterFunctions: any = {
      [MainTableFilterModulesEnum.DocumentsByMenu]: (filter: MainTableFilterModel) =>
        // filter.additional.menuId === additional.menuId &&
        filter.additional.tabName === additional.tabName,
      [MainTableFilterModulesEnum.Users]: (filter: MainTableFilterModel) =>
        filter.additional.includeDeleted === additional.includeDeleted &&
        filter.additional.includePaused === additional.includePaused &&
        filter.additional.includeDeactivated === additional.includeDeactivated,
      // Product owner users keep one filter per module; additional only carries includeDeleted state.
      [MainTableFilterModulesEnum.ProductOwnerUsers]: (filter: MainTableFilterModel) =>
        filter.module === module,
      [MainTableFilterModulesEnum.Messages]: (filter: MainTableFilterModel) =>
        filter.module === module,
      [MainTableFilterModulesEnum.Tasks]: (filter: MainTableFilterModel) =>
        filter.additional.menuId === additional.menuId &&
        filter.additional.showDeleted === additional.showDeleted,
      [MainTableFilterModulesEnum.Drills]: (filter: MainTableFilterModel) =>
        filter.additional.menuId === additional.menuId &&
        filter.additional.showDeleted === additional.showDeleted,
      [MainTableFilterModulesEnum.Certificates]: (filter: MainTableFilterModel) =>
        filter.additional.menuId === additional.menuId &&
        filter.additional.showDeleted === additional.showDeleted,
      [MainTableFilterModulesEnum.MaintenanceJobs]: (filter: MainTableFilterModel) =>
        filter.additional.componentId === additional.componentId &&
        filter.additional.showDeleted === additional.showDeleted,
      [MainTableFilterModulesEnum.UserActivities]: (filter: MainTableFilterModel) =>
        getUserActivitiesUserId(filter.additional) === getUserActivitiesUserId(additional),
      [MainTableFilterModulesEnum.MyUserActivities]: (filter: MainTableFilterModel) =>
        getUserActivitiesUserId(filter.additional) === getUserActivitiesUserId(additional),
      [MainTableFilterModulesEnum.Trips]: (filter: MainTableFilterModel) =>
        filter.additional?.status === additional?.status,
      [MainTableFilterModulesEnum.Projects]: (filter: MainTableFilterModel) =>
        filter.additional?.includeCompleted === additional?.includeCompleted,
      [MainTableFilterModulesEnum.DueListWarnings]: (filter: MainTableFilterModel) =>
        filter.additional?.displayRuntimeChildren === additional?.displayRuntimeChildren,
      [MainTableFilterModulesEnum.DueListMyWarnings]: (filter: MainTableFilterModel) =>
        filter.additional?.displayRuntimeChildren === additional?.displayRuntimeChildren,
      default: (filter: MainTableFilterModel) => filter.additional === additional,
      [MainTableFilterModulesEnum.WorkRest]: (filter: MainTableFilterModel) =>
        filter.module === module,
      [MainTableFilterModulesEnum.SignOffHistory]: (filter: MainTableFilterModel) =>
        filter.module === module,
    };
    return (filter: MainTableFilterModel) => {
      if (filter.module !== module) {
        return false;
      }
      const additionalFilterFunction = filterFunctions[module] || filterFunctions.default;
      return additionalFilterFunction(filter);
    };
  }

  private clearColumnFromFilter(
    filter: MainTableFilterModel,
    column: string
  ): MainTableFilterModel {
    const clearedFilter = cloneDeep(filter);
    clearedFilter.searchBy = this.clearColumnFromSearchBy(clearedFilter.searchBy, column);

    if (clearedFilter.orderBy === column) {
      clearedFilter.orderBy = '';
      clearedFilter.ascDesc = '';
    }

    return clearedFilter;
  }

  private filterHasColumn(filter: MainTableFilterModel, column: string): boolean {
    return (
      filter.orderBy === column || (filter.searchBy ?? []).some((item) => item.property === column)
    );
  }

  private clearColumnFromSearchBy(
    searchBy: MainTableFilterSearchByModel[] | undefined,
    column: string
  ): MainTableFilterSearchByModel[] {
    return (searchBy ?? []).filter((filter) => filter.property !== column);
  }

  private clearColumnFromModuleSearchBy(
    moduleSearchBy: MainTableFilterStateModel['moduleSearchBy'],
    module: MainTableFilterModulesEnum,
    column: string
  ): MainTableFilterStateModel['moduleSearchBy'] {
    const remaining = this.clearColumnFromSearchBy(moduleSearchBy[module], column);
    if (!remaining.length) {
      const nextSearchBy = { ...moduleSearchBy };
      delete nextSearchBy[module];
      return nextSearchBy;
    }

    return {
      ...moduleSearchBy,
      [module]: remaining,
    };
  }

  private clearColumnFromModuleSorting(
    moduleSorting: MainTableFilterStateModel['moduleSorting'],
    module: MainTableFilterModulesEnum,
    column: string
  ): MainTableFilterStateModel['moduleSorting'] {
    if (moduleSorting[module]?.orderBy !== column) {
      return moduleSorting;
    }

    const nextSorting = { ...moduleSorting };
    delete nextSorting[module];
    return nextSorting;
  }

  private updateExistingFilter(
    ctx: StateContext<MainTableFilterStateModel>,
    filter: MainTableFilterModel,
    module: MainTableFilterModulesEnum,
    additional: any
  ): void {
    ctx.setState(
      patch({
        filtersByModule: updateItem<MainTableFilterModel>(
          MainTableFilterState.findFilterFn(module, additional),
          filter
        ),
        currentFilter: filter,
      })
    );
  }

  private addNewFilter(
    ctx: StateContext<MainTableFilterStateModel>,
    filter: MainTableFilterModel
  ): void {
    ctx.setState(
      patch({
        filtersByModule: append([filter]),
        currentFilter: filter,
      })
    );
  }

  private setModuleSorting(
    ctx: StateContext<MainTableFilterStateModel>,
    module: string,
    orderBy: string,
    ascDesc: MainTableSortingType
  ) {
    ctx.setState(
      patch({
        moduleSorting: {
          ...ctx.getState().moduleSorting,
          [module]: {
            orderBy,
            ascDesc,
          },
        },
      })
    );
    this.tableFilterStorageService.saveModuleSorting(module, { orderBy, ascDesc });
  }

  private setModuleSearchBy(
    ctx: StateContext<MainTableFilterStateModel>,
    module: string,
    filters: MainTableFilterSearchByModel[]
  ) {
    ctx.setState(
      patch({
        moduleSearchBy: {
          ...ctx.getState().moduleSearchBy,
          [module]: filters,
        },
      })
    );
    this.tableFilterStorageService.saveModuleSearchBy(module, filters);
  }

  private setModulePageSize(
    ctx: StateContext<MainTableFilterStateModel>,
    module: string,
    pageSize: number
  ) {
    ctx.setState(
      patch({
        modulePageSizes: {
          ...ctx.getState().modulePageSizes,
          [module]: pageSize,
        },
      })
    );
    this.tableFilterStorageService.saveModulePageSize(module, pageSize);
  }

  private setModuleSearchTerm(
    ctx: StateContext<MainTableFilterStateModel>,
    module: string,
    searchTerm: string
  ) {
    ctx.setState(
      patch({
        moduleSearchTerm: {
          ...ctx.getState().moduleSearchTerm,
          [module]: searchTerm,
        },
      })
    );
    this.rememberSearchTermForCurrentScope(ctx, module, searchTerm);
    this.tableFilterStorageService.saveModuleSearchTerm(module, searchTerm);
  }

  private rememberSearchTermForCurrentScope(
    ctx: StateContext<MainTableFilterStateModel>,
    module: string,
    searchTerm: string
  ): void {
    const scope = this.tableFilterStorageService.currentTableScope();
    if (!scope) {
      return;
    }
    const state = ctx.getState();
    ctx.setState(
      patch({
        searchTermByScope: {
          ...state.searchTermByScope,
          [scope]: {
            ...(state.searchTermByScope[scope] ?? {}),
            [module]: searchTerm,
          },
        },
      })
    );
  }

  private applyScopeToFilter(
    filter: MainTableFilterModel,
    moduleSearchBy: MainTableFilterStateModel['moduleSearchBy'],
    moduleSorting: MainTableFilterStateModel['moduleSorting'],
    moduleSearchTerm: MainTableFilterStateModel['moduleSearchTerm']
  ): MainTableFilterModel {
    const nextFilter = cloneDeep(filter);
    const sorting = moduleSorting[filter.module];
    nextFilter.searchBy = moduleSearchBy[filter.module] || [];
    nextFilter.searchTerm = moduleSearchTerm[filter.module] || '';
    nextFilter.orderBy = sorting?.orderBy || '';
    nextFilter.ascDesc = sorting?.ascDesc || '';
    return nextFilter;
  }

  private dispatchFilterToProperModule(
    filter: MainTableFilterModel,
    module: MainTableFilterModulesEnum,
    ctx: StateContext<MainTableFilterStateModel>
  ): void {
    try {
      const action = this.actionMap[module];
      if (!action) {
        console.warn(`No action handler found for module: ${module}`);
        return;
      }
      ctx.dispatch(action(filter));
    } catch (error) {
      console.error(`Error dispatching filter for module ${module}:`, error);
    }
  }
}
